import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77a8ed80"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "10",
  height: "7",
  viewBox: "0 0 10 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.104884 1.50596L4.67976 6.6922C4.72096 6.73575 4.77061 6.77044 4.82567 6.79415C4.88073 6.81785 4.94005 6.83008 5 6.83008C5.05995 6.83008 5.11927 6.81785 5.17433 6.79415C5.22939 6.77044 5.27904 6.73575 5.32024 6.6922L9.89512 1.50596C9.93169 1.46476 9.95972 1.41671 9.97757 1.36459C9.99541 1.31247 10.0027 1.25733 9.99909 1.20236C9.99458 1.14694 9.97901 1.093 9.95329 1.04371C9.92758 0.994417 9.89224 0.950784 9.84937 0.915386L9.07996 0.270744C9.03793 0.234389 8.98904 0.206825 8.93618 0.189682C8.88332 0.172537 8.82756 0.166162 8.77219 0.170929C8.71709 0.174915 8.66333 0.189841 8.61406 0.214834C8.56479 0.239827 8.52099 0.274386 8.48522 0.316493L5.0707 4.24673C5.04968 4.26755 5.02128 4.27924 4.99168 4.27924C4.96209 4.27924 4.93369 4.26755 4.91266 4.24673L1.51478 0.316493C1.44755 0.236188 1.35249 0.184205 1.2486 0.170929C1.19352 0.165595 1.13793 0.171309 1.08508 0.187734C1.03223 0.20416 0.983193 0.230967 0.940838 0.266585L0.150633 0.915386C0.107763 0.950784 0.0724248 0.994417 0.0467083 1.04371C0.0209918 1.093 0.0054186 1.14694 0.000909419 1.20235C-0.00273159 1.25733 0.00458484 1.31247 0.0224338 1.36459C0.0402828 1.41671 0.0683087 1.46476 0.104884 1.50596Z",
    fill: "#387DFF"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { PropType, onMounted, onUnmounted } from "vue";
import { ref, watch, nextTick } from "vue";
import DatePicker from "vue3-datepicker";
import VRuntimeTemplate from "vue3-runtime-template";


export default /*#__PURE__*/_defineComponent({
  __name: 'datePickInput',
  props: {
  disabled: { type: Boolean, required: false },
  modelValue: {
    type: [Date, String] as PropType<Date | string>,
    required: false,
    default: () => null,
  },
  placeholder: { type: String, required: false, default: "Select date" },
  validState: {
    type: Boolean as PropType<boolean | null>,
    required: false,
    default: null,
  },
  dataCyId: { type: String, required: false, default: "" },
  className: { type: String, required: false, default: "" },
  classNameIcon: { type: String, required: false, default: "" },
  focus: { type: Boolean, required: false, default: null },
  isAutoFocus: { type: Boolean, required: false, default: false },
  textColor: { type: String, required: false, default: "#231f20" },
  refPicker: { type: String, required: false, default: "" },
  /** Vue Validation object */
  validation: { type: Object, default: () => ({}) },
  showValidContent: { type: Boolean, required: false, default: false },
  customInputClass: { type: String, required: false, default: "" },
},
  emits: ["update:modelValue", "on:focus"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "4beafcdc": (__props.textColor)
}))



let dateInput: any = ref(
  props.modelValue ? new Date(`${props.modelValue}`) : null,
);
const dateRef = ref();
const refPickers = ref();
const isOpen = ref(false);

onMounted(() => {
  if (dateRef.value && props.isAutoFocus) {
    dateRef.value.focus();
    isOpen.value = true;
  }
  eventEmitter.on(EmitterEvents.SCROLL_MODAL, adjustPosition);
});

onUnmounted(() => {
  eventEmitter.off(EmitterEvents.SCROLL_MODAL);
});

watch(
  () => props.modelValue,
  (newVal) => {
    if (typeof newVal === "string") {
      dateInput.value = newVal ? new Date(newVal) : null;
    }
  },
);

watch(dateInput, (newVal) => {
  emit("update:modelValue", newVal);
});

const formatDate = (val) => {
  if (dateInput.value) {
    return convertUTCTimeToLocalTime(dateInput.value);
  }
  return;
};

const clicked = () => {
  if (dateRef.value) {
    dateRef.value.focus();
    isOpen.value = true;
  }
  if (refPickers.value) {
    refPickers.value.focus();
    isOpen.value = true;
  }
};

const close = () => {
  props.validation?.$touch && props.validation.$touch();
  if (dateRef.value) {
    dateRef.value.blur();
    isOpen.value = false;
  }
  if (refPickers.value) {
    refPickers.value.blur();
    isOpen.value = false;
  }
};

const adjustPosition = () => {
  nextTick(() => {
    const datepickers = document.getElementsByClassName("v3dp__popout");
    const modals = document.getElementsByClassName("date-picker-modal");

    if (!modals.length) return;

    for (let i = 0; i < datepickers.length; i++) {
      const datepicker = datepickers[i] as HTMLElement;
      datepicker.style.position = "absolute";
      datepicker.style.transform = ``;
    }

    if (datepickers.length && modals.length) {
      const datepicker = findVisibleElement("v3dp__popout") as HTMLElement;
      if (!datepicker) return;
      const modal = modals[modals.length - 1] as HTMLElement;
      const modalRect = modal.getBoundingClientRect();
      const rect = datepicker.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Adjust position if needed
      if (rect.bottom > modalRect.bottom) {
        datepicker.style.position = "fixed";
        if (rect.bottom > windowHeight) {
          datepicker.style.transform = `translateY(${
            windowHeight - rect.bottom - modal.scrollTop
          }px)`;
        } else {
          datepicker.style.transform = `translateY(-${modal.scrollTop}px)`;
        }
      }
    }
  });
};

const findVisibleElement = (className) => {
  const elements = document.getElementsByClassName(className);
  for (let item of elements) {
    let element = item as HTMLElement;
    if (element.style.display !== "none") {
      return element;
    }
  }
  return null; // No visible element found
};

const handleFocus = () => {
  if (props.focus) clicked();
  emit("on:focus", true);
};

__expose({ clicked });


return (_ctx: any,_cache: any) => {
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DatePicker), {
      ref_key: "dateRef",
      ref: dateRef,
      modelValue: _unref(dateInput),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dateInput) ? (dateInput).value = $event : dateInput = $event)),
      typeable: "",
      class: "tw-hidden",
      disabled: __props.disabled,
      onOpened: adjustPosition,
      onClosed: _cache[1] || (_cache[1] = 
      () => {
        // refPicker ? refPickers.blur() : dateRef.blur();
        isOpen.value = false;
      }
    )
    }, null, 8, ["modelValue", "disabled"]),
    _createElementVNode("div", {
      class: _normalizeClass(`tw-relative ${__props.customInputClass}`)
    }, [
      _createVNode(_component_BFormInput, {
        "model-value": formatDate(__props.focus),
        type: "text",
        "data-cy": __props.dataCyId,
        placeholder: __props.placeholder,
        state: __props.validState,
        class: _normalizeClass([
        'input-wizard-question autoFocus',
        __props.className,
        `${__props.validation?.$error ? 'is-invalid-input' : ''}`,
      ]),
        disabled: __props.disabled,
        autofocus: __props.isAutoFocus,
        onBlur: close,
        onFocus: handleFocus,
        onInput: () => {},
        onKeydown: _cache[2] || (_cache[2] = 
        (e) => {
          if (e.key !== 'Tab') e.preventDefault();
        }
      ),
        onClick: clicked
      }, null, 8, ["model-value", "data-cy", "placeholder", "state", "class", "disabled", "autofocus"]),
      _createElementVNode("div", {
        class: _normalizeClass(`date-picker-icon ${__props.classNameIcon} tw-absolute !tw-pointer-events-none tw-top-[16px] tw-right-[20px] ${
        isOpen.value ? 'tw-rotate-180' : ''
      }`)
      }, _hoisted_2, 2),
      (__props.showValidContent)
        ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
            key: 0,
            class: _normalizeClass({ 'is-invalid': __props.validation.$error })
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VRuntimeTemplate), {
                template: __props.validation?.$errors?.[0]?.$message
              }, null, 8, ["template"])
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})